module.exports = __webpack_public_path__ + "static/media/consdata.5409484e.jpeg";